"use client";

import React from "react";
import { Calendar, BookOpen, Mic, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offerings = [{
  title: "In-Store Events",
  description: "Hands-on wellness experiences in an intimate, personal setting designed for connection.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/in_store_events.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/in_store_events.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/in_store_events.png-wvc-sizes",
    alt: "People gathering for an in-store wellness event"
  },
  icon: Calendar
}, {
  title: "M/O Book Club",
  description: "Fostering personal growth and real, meaningful conversations through curated reading.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo_book_club.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo_book_club.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/mo_book_club.png-wvc-sizes",
    alt: "Books stacked on a table for a book club meeting"
  },
  icon: BookOpen
}, {
  title: "Guest Speakers",
  description: "Learn directly from industry experts, thought leaders, and wellness practitioners.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/guest_speakers.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/guest_speakers.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/guest_speakers.png-wvc-sizes",
    alt: "A guest speaker presenting to an audience"
  },
  icon: Mic
}, {
  title: "Wellness Retreats",
  description: "Immersive, high-end experiences designed to completely rejuvenate your mind and body.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_retreats.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_retreats.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_retreats.png-wvc-sizes",
    alt: "A serene landscape representing a wellness retreat"
  },
  icon: MapPin
}];
export default function WhatYoullFind() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="what-youll-find" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight mb-4">
            What You'll Find
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Discover our curated selection of experiences designed to elevate your well-being and foster community.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {offerings.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="overflow-hidden border-border/50 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 group bg-card">
                <AspectRatio ratio={4 / 3} className="bg-muted overflow-hidden">
                  <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute top-4 left-4 bg-background/90 backdrop-blur-sm p-2 rounded-full shadow-sm">
                    <Icon className="w-5 h-5 text-foreground" />
                  </div>
                </AspectRatio>
                <CardHeader className="pb-2 pt-6">
                  <CardTitle className="text-xl font-default font-semibold">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base font-sans text-muted-foreground leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}